import React from "react";
import { useNavigate } from "react-router-dom";

const PelvisHipsFrontPT = () => {
  const navigate = useNavigate();

  return (
    <>
      <style>{`
        .pelvis-page {
          min-height: 100vh;
          width: 100%;
          background: radial-gradient(circle at top left, #fefce8 0, #f9fafb 40%, #e5e7eb 100%);
          font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          color: #0f172a;
        }

        .pelvis-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 32px 16px 72px;
        }

        /* HERO */
        .pelvis-hero {
          padding: 26px 22px 30px;
          border-radius: 28px;
          background: linear-gradient(115deg, rgba(234, 179, 8, 0.16), rgba(59, 130, 246, 0.05));
          margin-bottom: 32px;
          display: grid;
          grid-template-columns: minmax(0, 1.6fr) minmax(0, 1.1fr);
          gap: 24px;
          align-items: center;
        }

        @media (max-width: 820px) {
          .pelvis-hero {
            grid-template-columns: 1fr;
          }
        }

        .pelvis-tag {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 5px 12px;
          border-radius: 999px;
          background: rgba(234, 179, 8, 0.25);
          color: #854d0e;
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.08em;
          margin-bottom: 8px;
        }

        .pelvis-tagDot {
          width: 6px;
          height: 6px;
          border-radius: 999px;
          background: #ca8a04;
        }

        .pelvis-title {
          font-size: clamp(28px, 4vw, 36px);
          font-weight: 800;
          line-height: 1.1;
          margin-bottom: 8px;
        }

        .pelvis-subtitle {
          font-size: 15px;
          max-width: 540px;
          color: #374151;
        }

        .pelvis-chips {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin: 14px 0 16px;
        }

        .pelvis-chip {
          padding: 6px 12px;
          border-radius: 999px;
          background: #0f172a;
          color: #f9fafb;
          font-size: 11px;
        }

        .pelvis-ctaRow {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 8px;
        }

        .pelvis-btnPrimary,
        .pelvis-btnSecondary {
          border-radius: 999px;
          border: none;
          font-size: 14px;
          padding: 9px 18px;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          transition: transform 0.12s ease, box-shadow 0.12s ease, background 0.12s ease;
        }

        .pelvis-btnPrimary {
          background: #eab308;
          color: #1f2937;
          box-shadow: 0 9px 22px rgba(234, 179, 8, 0.4);
        }

        .pelvis-btnPrimary:hover {
          transform: translateY(-1px);
          box-shadow: 0 12px 28px rgba(234, 179, 8, 0.52);
        }

        .pelvis-btnSecondary {
          background: rgba(15, 23, 42, 0.06);
          color: #111827;
          border: 1px solid rgba(148, 163, 184, 0.7);
        }

        .pelvis-btnSecondary:hover {
          background: rgba(15, 23, 42, 0.1);
          transform: translateY(-1px);
        }

        .pelvis-heroImgWrap {
          display: flex;
          justify-content: center;
        }

        .pelvis-heroImg {
          width: 100%;
          max-width: 380px;
          border-radius: 24px;
          object-fit: cover;
          box-shadow: 0 18px 38px rgba(15, 23, 42, 0.24);
        }

        /* STRIPES */
        .pelvis-stripe {
          padding: 30px 0;
          border-bottom: 1px solid rgba(148, 163, 184, 0.4);
        }

        .pelvis-sectionTitle {
          font-size: 20px;
          font-weight: 800;
          margin-bottom: 8px;
        }

        .pelvis-sectionSubtitle {
          font-size: 13px;
          color: #4b5563;
          margin-bottom: 16px;
        }

        .pelvis-flexRow {
          display: flex;
          flex-wrap: wrap;
          gap: 24px;
          align-items: center;
        }

        .pelvis-flexCol {
          flex: 1 1 260px;
        }

        .pelvis-img {
          width: 100%;
          max-width: 360px;
          border-radius: 22px;
          object-fit: cover;
          box-shadow: 0 14px 30px rgba(15, 23, 42, 0.18);
        }

        .pelvis-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: grid;
          gap: 7px;
        }

        .pelvis-list li {
          display: flex;
          gap: 8px;
          font-size: 14px;
          color: #111827;
        }

        .pelvis-bullet {
          width: 7px;
          height: 7px;
          border-radius: 999px;
          margin-top: 6px;
          background: #eab308;
          flex-shrink: 0;
        }

        /* 2x2 GRID CARDS */
        .pelvis-cardGrid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 16px;
          margin-top: 18px;
        }

        .pelvis-card {
          padding: 12px 14px;
          border-radius: 18px;
          background: rgba(15, 23, 42, 0.02);
          border: 1px solid rgba(148, 163, 184, 0.5);
        }

        .pelvis-cardTitle {
          font-size: 13px;
          font-weight: 700;
          margin-bottom: 4px;
        }

        .pelvis-cardText {
          font-size: 12px;
          color: #4b5563;
        }

        /* TIMELINE */
        .pelvis-timeline {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
          gap: 10px;
        }

        .pelvis-step {
          border-radius: 18px;
          padding: 10px 12px;
          background: rgba(15, 23, 42, 0.03);
        }

        .pelvis-stepLabel {
          font-size: 12px;
          font-weight: 700;
          margin-bottom: 4px;
        }

        .pelvis-stepText {
          font-size: 12px;
          color: #4b5563;
        }

        /* BANNER */
        .pelvis-banner {
          position: relative;
          border-radius: 26px;
          overflow: hidden;
          margin-top: 18px;
        }

        .pelvis-banner img {
          width: 100%;
          height: 230px;
          object-fit: cover;
          display: block;
        }

        @media (min-width: 768px) {
          .pelvis-banner img {
            height: 260px;
          }
        }

        .pelvis-bannerOverlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(90deg, rgba(15, 23, 42, 0.78), transparent 60%);
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 18px 20px;
          gap: 8px;
        }

        .pelvis-bannerText {
          color: #fef9c3;
          font-size: 15px;
          max-width: 420px;
        }

        .pelvis-bannerButtons {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin-top: 6px;
        }

        .pelvis-bannerButtons button {
          font-size: 12px;
          padding: 7px 12px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .pelvis-bannerButtons .primary {
          background: #22c55e;
          color: #022c22;
        }

        .pelvis-bannerButtons .secondary {
          background: rgba(255, 255, 255, 0.16);
          color: #f9fafb;
          border: 1px solid rgba(255, 255, 255, 0.6);
        }

        /* BOTTOM SAFETY STRIP */
        .pelvis-bottomStrip {
          margin-top: 24px;
          padding: 14px 14px;
          border-radius: 22px;
          background: #0f172a;
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          align-items: center;
          justify-content: space-between;
        }

        .pelvis-bottomText {
          font-size: 12px;
          color: #e5e7eb;
          flex: 1 1 240px;
        }

        .pelvis-bottomText strong {
          color: #fef9c3;
        }

        .pelvis-bottomActions {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .pelvis-bottomActions button {
          font-size: 12px;
          padding: 7px 12px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .pelvis-bottomActions .primary {
          background: #eab308;
          color: #111827;
        }

        .pelvis-bottomActions .secondary {
          background: transparent;
          color: #e5e7eb;
          border: 1px solid rgba(148, 163, 184, 0.8);
        }

        @media (max-width: 640px) {
          .pelvis-title {
            font-size: 26px;
          }
        }
      `}</style>

      <div className="pelvis-page">
        <div className="pelvis-inner">
          {/* HERO */}
          <section className="pelvis-hero">
            <div>
              <div className="pelvis-tag">
                <span className="pelvis-tagDot" />
                Pelvis & Hips (Front)
              </div>
              <h1 className="pelvis-title">
                Support your pelvis & front hips so walking, sitting, and standing feel more natural.
              </h1>
              <p className="pelvis-subtitle">
                The pelvic floor, hip joints, iliopsoas, and TFL help control posture, walking,
                and how your legs connect to your core. When they&apos;re tight, weak, or irritated,
                they can create front hip pain, groin pull feelings, or deep pelvic discomfort.
              </p>

              <div className="pelvis-chips">
                <span className="pelvis-chip">Front hip pinching</span>
                <span className="pelvis-chip">Groin pulling</span>
                <span className="pelvis-chip">Hip flexor tightness</span>
                <span className="pelvis-chip">Pelvic tension or heaviness</span>
              </div>

              <div className="pelvis-ctaRow">
                <button
                  className="pelvis-btnPrimary"
                  onClick={() => navigate("/appointments")}
                >
                  Book a pelvis & hip visit →
                </button>
                <button
                  className="pelvis-btnSecondary"
                  onClick={() => navigate("/staff")}
                >
                  Meet our therapists
                </button>
              </div>
            </div>

            <div className="pelvis-heroImgWrap">
              <img
                src="/content/pelvis-hips-front/pelvis_hips_hero.png"
                alt="Therapist assessing front hip and pelvis"
                className="pelvis-heroImg"
              />
            </div>
          </section>

          {/* WHAT CAN GO WRONG */}
          <section className="pelvis-stripe">
            <div className="pelvis-sectionTitle">What can go wrong in the front pelvis & hips?</div>
            <p className="pelvis-sectionSubtitle">
              The front of the hips and pelvis is a busy area. Hip flexors, pelvic floor, and
              stabilizers all share space and workload.
            </p>

            <div className="pelvis-flexRow">
              <div className="pelvis-flexCol">
                <ul className="pelvis-list">
                  <li>
                    <span className="pelvis-bullet" />
                    <span>
                      <strong>Hip joint irritation:</strong> deep pinch or ache in the front of the
                      hip with sitting, squatting, or lifting the leg.
                    </span>
                  </li>
                  <li>
                    <span className="pelvis-bullet" />
                    <span>
                      <strong>Iliopsoas tightness:</strong> deep front hip or groin tension, especially
                      after sitting or running.
                    </span>
                  </li>
                  <li>
                    <span className="pelvis-bullet" />
                    <span>
                      <strong>TFL overuse:</strong> outer front hip soreness that may link into
                      the IT band or lateral thigh.
                    </span>
                  </li>
                  <li>
                    <span className="pelvis-bullet" />
                    <span>
                      <strong>Pelvic floor tension:</strong> feelings of heaviness, gripping, or
                      difficulty relaxing the base of the pelvis (with medical clearance and when
                      appropriate for PT).
                    </span>
                  </li>
                  <li>
                    <span className="pelvis-bullet" />
                    <span>
                      <strong>Postural strain:</strong> hips feeling “stuck” in a forward tilt,
                      making the low back and front hips work overtime.
                    </span>
                  </li>
                </ul>

                <div className="pelvis-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="pelvis-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    See if your pelvis/hip symptoms fit →
                  </button>
                  <button
                    className="pelvis-btnSecondary"
                    onClick={() => navigate("/contact")}
                  >
                    Ask a quick question
                  </button>
                </div>
              </div>

              <div className="pelvis-flexCol" style={{ display: "flex", justifyContent: "center" }}>
                <img
                  src="/content/pelvis-hips-front/pelvis_iliopsoas.png"
                  alt="Therapist treating front hip flexor/iliopsoas area"
                  className="pelvis-img"
                />
              </div>
            </div>

            <div className="pelvis-cardGrid">
              <div className="pelvis-card">
                <div className="pelvis-cardTitle">Pelvic Floor (base of pelvis)</div>
                <div className="pelvis-cardText">
                  Helps support organs, control pressure, and work with your core and hips.
                </div>
              </div>
              <div className="pelvis-card">
                <div className="pelvis-cardTitle">Hip Joint</div>
                <div className="pelvis-cardText">
                  Ball-and-socket that connects your leg to the pelvis; sensitive to compression and rotation.
                </div>
              </div>
              <div className="pelvis-card">
                <div className="pelvis-cardTitle">Iliopsoas</div>
                <div className="pelvis-cardText">
                  Deep hip flexor that lifts your leg; often tight with sitting or certain sports.
                </div>
              </div>
              <div className="pelvis-card">
                <div className="pelvis-cardTitle">TFL (Tensor Fasciae Latae)</div>
                <div className="pelvis-cardText">
                  Outer front hip muscle that helps stabilize the hip and feeds into the IT band.
                </div>
              </div>
            </div>
          </section>

          {/* HOW PT HELPS */}
          <section className="pelvis-stripe">
            <div className="pelvis-flexRow">
              <div className="pelvis-flexCol">
                <img
                  src="/content/pelvis-hips-front/pelvis_tfl.png"
                  alt="Manual therapy on outer front hip/TFL region"
                  className="pelvis-img"
                />
              </div>

              <div className="pelvis-flexCol">
                <div className="pelvis-sectionTitle">How physical therapy supports the pelvis & front hips</div>
                <p className="pelvis-sectionSubtitle">
                  We focus on balance: helping muscles that are gripping too hard relax, and helping
                  quieter muscles wake up and share the work.
                </p>

                <ul className="pelvis-list">
                  <li>
                    <span className="pelvis-bullet" />
                    <span>
                      <strong>Hip joint mobilization:</strong> gentle movements to create space and
                      reduce pinch at the front of the joint.
                    </span>
                  </li>
                  <li>
                    <span className="pelvis-bullet" />
                    <span>
                      <strong>Soft-tissue work:</strong> targeted treatment to iliopsoas, TFL,
                      and surrounding muscles to reduce tightness.
                    </span>
                  </li>
                  <li>
                    <span className="pelvis-bullet" />
                    <span>
                      <strong>Pelvic and core coordination:</strong> linking deep core, pelvic floor,
                      and hip muscles to support movement.
                    </span>
                  </li>
                  <li>
                    <span className="pelvis-bullet" />
                    <span>
                      <strong>Gait and posture tweaks:</strong> small changes in how you stand, walk,
                      or sit to unload sensitive areas.
                    </span>
                  </li>
                  <li>
                    <span className="pelvis-bullet" />
                    <span>
                      <strong>Strength progression:</strong> building controlled strength for steps,
                      stairs, squats, and daily tasks.
                    </span>
                  </li>
                </ul>

                <div className="pelvis-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="pelvis-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    Start with one pelvic/hip session →
                  </button>
                  <button
                    className="pelvis-btnSecondary"
                    onClick={() => navigate("/insurance")}
                  >
                    Check my insurance
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* PELVIC FLOOR & CORE SECTION */}
          <section className="pelvis-stripe">
            <div className="pelvis-flexRow">
              <div className="pelvis-flexCol">
                <div className="pelvis-sectionTitle">Pelvic floor & deep core connection</div>
                <p className="pelvis-sectionSubtitle">
                  In many cases (when appropriate and medically cleared), PT can help you learn how
                  the pelvic floor, deep core, and hips share pressure and support.
                </p>

                <ul className="pelvis-list">
                  <li>
                    <span className="pelvis-bullet" />
                    <span>
                      Gentle, external guidance to help muscles relax and activate in a coordinated way.
                    </span>
                  </li>
                  <li>
                    <span className="pelvis-bullet" />
                    <span>
                      Breathing drills that reduce gripping and tension in the pelvis and abdomen.
                    </span>
                  </li>
                  <li>
                    <span className="pelvis-bullet" />
                    <span>
                      Gradual return plans for walking, daily tasks, and low-impact exercise.
                    </span>
                  </li>
                </ul>

                <div className="pelvis-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="pelvis-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    Ask about pelvic-focused PT →
                  </button>
                </div>
              </div>

              <div className="pelvis-flexCol" style={{ display: "flex", justifyContent: "center" }}>
                <img
                  src="/content/pelvis-hips-front/pelvis_floor_guidance.png"
                  alt="Therapist guiding breathing and gentle core work"
                  className="pelvis-img"
                />
              </div>
            </div>
          </section>

          {/* VISIT FLOW */}
          <section className="pelvis-stripe">
            <div className="pelvis-sectionTitle">What a pelvis & front hip visit may look like</div>

            <div className="pelvis-flexRow">
              <div className="pelvis-flexCol">
                <img
                  src="/content/pelvis-hips-front/pelvis_hip_flexor_exercises.png"
                  alt="Patient performing hip flexor and front hip exercises"
                  className="pelvis-img"
                />
              </div>

              <div className="pelvis-flexCol">
                <div className="pelvis-timeline">
                  <div className="pelvis-step">
                    <div className="pelvis-stepLabel">1. Your story</div>
                    <div className="pelvis-stepText">
                      You share where you feel front hip or pelvic discomfort, what movements bring it on,
                      and what you want to get back to.
                    </div>
                  </div>
                  <div className="pelvis-step">
                    <div className="pelvis-stepLabel">2. Motion & strength check</div>
                    <div className="pelvis-stepText">
                      We check hip range of motion, strength, and how your pelvis and core move together.
                    </div>
                  </div>
                  <div className="pelvis-step">
                    <div className="pelvis-stepLabel">3. Hands-on work</div>
                    <div className="pelvis-stepText">
                      You try specific manual techniques and stretches to see what eases tension.
                    </div>
                  </div>
                  <div className="pelvis-step">
                    <div className="pelvis-stepLabel">4. Short home plan</div>
                    <div className="pelvis-stepText">
                      You leave with a focused set of hip and core moves you can repeat without feeling overwhelmed.
                    </div>
                  </div>
                </div>

                <div className="pelvis-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="pelvis-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    Book a pelvis/hip evaluation →
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* BANNER */}
          <section className="pelvis-stripe">
            <div className="pelvis-banner">
              <img
                src="/content/pelvis-hips-front/pelvis_hips_banner.png"
                alt="Bright physical therapy clinic for hip and pelvic rehab"
              />
              <div className="pelvis-bannerOverlay">
                <div className="pelvis-bannerText">
                  Pelvis and hip sessions happen in a calm, one-on-one environment where we match
                  the plan to your comfort level and goals.
                </div>
                <div className="pelvis-bannerButtons">
                  <button
                    className="primary"
                    onClick={() => navigate("/appointments")}
                  >
                    Schedule pelvis & hip visit →
                  </button>
                  <button
                    className="secondary"
                    onClick={() => navigate("/office")}
                  >
                    View locations
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* SAFETY NOTE */}
          <section className="pelvis-stripe">
            <div className="pelvis-bottomStrip">
              <div className="pelvis-bottomText">
                If you notice sudden severe pelvic or hip pain, trauma, loss of bladder or bowel
                control, fever, or symptoms that feel urgent or different than muscle or joint pain,{" "}
                <strong>seek medical or emergency care first.</strong> Physical therapy can then help
                support your recovery once serious causes are ruled out.
              </div>
              <div className="pelvis-bottomActions">
                <button
                  className="primary"
                  onClick={() => navigate("/appointments")}
                >
                  Schedule pelvis & hip PT
                </button>
                <button
                  className="secondary"
                  onClick={() => navigate("/contact")}
                >
                  Message our team
                </button>
              </div>
            </div>
          </section>

        </div>
      </div>
    </>
  );
};

export default PelvisHipsFrontPT;
